export const REDIRECT_INIT = 'REDIRECT_INIT';
export const REDIRECT_DONE = 'REDIRECT_DONE';
